import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

interface NoseModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const NoseModal = ({ forceOpened = false, onClose }: NoseModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  useEffect(() => {
    if (searchParams?.get('modal') === 'nose' || forceOpened) {
      open();
    }
  }, [searchParams, open, forceOpened, close]);

  const items = [
    { id: 'method', label: '수술 방법', path: '/nose/method?from_modal=nose' },
    { id: 'implants', label: '보형물 종류', path: '/implants?from_modal=nose' },
    { id: 'sideeffects', label: '부작용', path: '/nose/side-effects?from_modal=nose' },
    { id: 'nosetypes', label: '코의 종류', path: '/nose/types?from_modal=nose' },
    { id: 'linetypes', label: '코 라인의 종류', path: '/nose/line-types?from_modal=nose' }
  ];

  const handleItemClick = (id: string) => {
    const item = items.find(item => item.id === id);
    if (item && item.path) {
      router.push(item.path);
      close();
      if (onClose) onClose();
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close();
          if (onClose) onClose();
        }}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
        <div className="flex flex-col gap-3 mb-5">
          <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
            코 성형
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 max-w-[560px] mx-auto">
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800`}
              onClick={() => item.id && handleItemClick(item.id)}
            >
              <div className="text-[15px] font-normal">
                {item.label}
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
            onClick={() => {
              close();
              if (onClose) onClose();
            }}
          >
            닫기
          </Button>
        </div>
      </Modal>
    </>
  )
};